(function () {
  if (window.ossCartTransactions) return;
  var busy = false;
  var uncertain = false;
  var revision = 0;
  var empty = false;
  var savedControls = new Map();
  var renderers = [];
  var checkoutSelector = '.oss-ajax-cart__checkout, .oss-checkout-btn';
  var controlSelector = '[data-oss-ajax-cart-key] button, [data-oss-ajax-cart-qty], [data-oss-cart-line] button, [data-oss-cart-qty], [data-oss-ajax-cart-recommendation-add], [data-oss-cart-discount-submit], [data-oss-cart-discount-input], [data-oss-ajax-cart-discount-input], [data-oss-ajax-cart-discount-form] button';

  function route(path) {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path;
  }
  function status(message, retry) {
    document.querySelectorAll('[data-oss-cart-status]').forEach(function (node) {
      node.replaceChildren();
      node.hidden = !message;
      node.style.display = message ? 'block' : 'none';
      if (!message) return;
      var text = document.createElement('span');
      text.textContent = message + ' ';
      node.appendChild(text);
      var link = document.createElement('a');
      link.href = route('cart');
      link.textContent = 'View Cart';
      node.appendChild(link);
      if (retry) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'Retry Cart Preview';
        button.style.marginLeft = '8px';
        button.addEventListener('click', function () {
          if (busy) return;
          busy = true;
          syncControls();
          refresh().then(function () { status(''); }).catch(function () {
            status('We couldn’t confirm the latest cart. Please check your cart before trying again.', true);
          }).finally(end);
        });
        node.appendChild(button);
      }
    });
    var drawer = document.querySelector('[data-oss-ajax-cart].is-open .oss-ajax-cart__panel');
    if (message && drawer) drawer.scrollTop = 0;
    if (message && !drawer) {
      var pageStatus = document.querySelector('.oss-cart-page [data-oss-cart-status]');
      if (pageStatus) pageStatus.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
  }
  function syncControls() {
    document.querySelectorAll(controlSelector).forEach(function (node) {
      if (busy || uncertain) {
        if (!savedControls.has(node)) savedControls.set(node, node.disabled);
        node.disabled = true;
      } else if (savedControls.has(node)) {
        node.disabled = savedControls.get(node);
        savedControls.delete(node);
      }
    });
    document.querySelectorAll(checkoutSelector).forEach(function (node) {
      if (busy || uncertain || empty) {
        if (!savedControls.has(node)) savedControls.set(node, { disabled: node.disabled, aria: node.getAttribute('aria-disabled') });
        if ('disabled' in node) node.disabled = true;
        node.setAttribute('aria-disabled', 'true');
      } else if (savedControls.has(node)) {
        var previous = savedControls.get(node);
        if ('disabled' in node) node.disabled = previous.disabled;
        if (previous.aria === null) node.removeAttribute('aria-disabled');
        else node.setAttribute('aria-disabled', previous.aria);
        savedControls.delete(node);
      }
    });
    savedControls.forEach(function (_, node) { if (!node.isConnected) savedControls.delete(node); });
  }
  function begin() {
    if (busy) return false;
    if (uncertain) {
      status('We couldn’t confirm the latest cart. Please check your cart before trying again.', true);
      return false;
    }
    busy = true;
    revision++;
    status('');
    syncControls();
    return true;
  }
  function end() { busy = false; syncControls(); }
  async function request(path, body, requestOptions) {
    requestOptions = requestOptions || {};
    var controller = new AbortController();
    var abort = function () { controller.abort(); };
    var externalSignal = requestOptions.signal;
    if (externalSignal) {
      if (externalSignal.aborted) abort();
      else externalSignal.addEventListener('abort', abort, { once: true });
    }
    var timer = window.setTimeout(abort, requestOptions.timeoutMs || 12000);
    try {
      var options = { signal: controller.signal, cache: 'no-store', headers: { Accept: 'application/json' } };
      if (body) {
        options.method = 'POST';
        options.body = body instanceof FormData ? body : JSON.stringify(body);
        if (!(body instanceof FormData)) options.headers['Content-Type'] = 'application/json';
      }
      var response = await fetch(route(path), options);
      var payload = await response.json().catch(function () { return null; });
      if (!response.ok) {
        var error = new Error(payload && (payload.description || payload.message) || 'Cart request failed (HTTP ' + response.status + ').');
        error.definite = true;
        throw error;
      }
      if (!payload || (path === 'cart/add.js'
        ? !(payload.id && payload.quantity > 0 || Array.isArray(payload.items) && payload.items.length && payload.items.every(function (item) { return item.id && item.quantity > 0; }))
        : !Array.isArray(payload.items) || !Number.isFinite(payload.item_count) || !Number.isFinite(payload.total_price))) {
        throw new Error('The cart returned an invalid response.');
      }
      return payload;
    } finally {
      window.clearTimeout(timer);
      if (externalSignal) externalSignal.removeEventListener('abort', abort);
    }
  }
  async function accept(cart) {
    for (var i = 0; i < renderers.length; i++) await renderers[i](cart);
    uncertain = false;
    empty = cart.item_count === 0;
    document.querySelectorAll('[data-oss-cart-unconfirmed]').forEach(function (node) { node.removeAttribute('data-oss-cart-unconfirmed'); });
    syncControls();
    return cart;
  }
  function refresh() { return request('cart.js').then(accept); }
  function markUnconfirmed() {
    uncertain = true;
    document.querySelectorAll('[data-oss-ajax-cart-count]').forEach(function (node) { node.textContent = '—'; });
    document.querySelectorAll('.oss-ajax-cart__item[aria-busy]').forEach(function (node) { node.removeAttribute('aria-busy'); });
    document.querySelectorAll('[data-oss-ajax-cart], .oss-cart-page').forEach(function (node) { node.setAttribute('data-oss-cart-unconfirmed', ''); });
    syncControls();
  }
  function identity(item) {
    var properties = item.properties || {};
    var entries = Object.keys(properties).sort().map(function (key) { return [key, String(properties[key])]; });
    var plan = item.selling_plan || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || '';
    return JSON.stringify([String(item.variant_id || item.id), String(plan), entries]);
  }
  function quantities(cart) {
    var result = {};
    cart.items.forEach(function (item) { var key = identity(item); result[key] = (result[key] || 0) + item.quantity; });
    return result;
  }
  function addOutcome(before, after, target, quantity) {
    var a = quantities(before), b = quantities(after), keys = Array.from(new Set(Object.keys(a).concat(Object.keys(b))));
    if (keys.some(function (key) { return key !== target && (a[key] || 0) !== (b[key] || 0); })) return 'unknown';
    var delta = (b[target] || 0) - (a[target] || 0);
    return delta === quantity ? 'added' : delta === 0 ? 'unchanged' : 'unknown';
  }
  document.addEventListener('click', function (event) {
    if ((busy || uncertain || empty) && event.target.closest(checkoutSelector)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (event) {
    if ((busy || uncertain || empty) && (event.target.matches('.oss-cart-page form') || event.submitter && event.submitter.matches(checkoutSelector))) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.ossCartTransactions = { begin: begin, end: end, request: request, accept: accept, refresh: refresh,
    status: status, markUnconfirmed: markUnconfirmed, identity: identity, addOutcome: addOutcome,
    register: function (render) { renderers.push(render); }, version: function () { return revision; }, isBusy: function () { return busy || uncertain; } };
})();
